@if (formData) {
    <tec-collapse
        [icon]="'icon-capture-popup'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.DATA' | translate"
        [expanded]="expandedCollapseSection === 'data'"
        (clickEvent)="toggleCollapse('data', $event)"
    >
        @if (
            formData.state !== OPERATION_STATUS.INIT &&
            formData.state !== OPERATION_STATUS.NOT_STARTED
        ) {
            @if (dataSections.length) {
                <app-form-operation-detail-sections
                    [sections]="dataSections"
                />
            } @else {
                <tec-empty-state
                    [title]="'OPERATIONS.DETAIL.FORM.NO_RESPONSES' | translate"
                    [size]="'default'"
                    [type]="'empty'"
                />
            }
        } @else {
            <tec-empty-state
                [title]="'GENERAL.NO_DATA' | translate"
                [size]="'default'"
                [type]="'empty'"
            />
        }
    </tec-collapse>

    <tec-collapse
        [icon]="'icon-pending-check'"
        [title]="'OPERATIONS.DETAIL.TABS.DETAILS.OPERATION' | translate"
        [expanded]="expandedCollapseSection === 'operation'"
        (clickEvent)="toggleCollapse('operation', $event)"
    >
        @if (formData.state !== OPERATION_STATUS.INIT && formData.state !== OPERATION_STATUS.NOT_STARTED) {
            <app-operation-detail-operation-meta
                variant="operation"
                [operationUuid]="formData.uuid ?? detail.uuid"
                [processUuid]="detail.process_uuid"
                [startAt]="formData.start_at ?? detail.start_at"
                [endAt]="formData.end_at ?? detail.end_at"
                [totalTime]="formData.total_time ?? detail.total_time"
                triesStyle="badge"
                [triesLabel]="formTriesLabel()"
                [state]="displayState ?? detail.state_name"
                [showKoOnTries]="true"
            />
        } @else {
            <tec-empty-state
                [title]="'GENERAL.NO_DATA' | translate"
                [size]="'default'"
                [type]="'empty'"
            />
        }
    </tec-collapse>
}
